import { WalletConfigType } from './wallet-config-type.interface';
import {
  WALLET_NAMES,
  WALLET_TYPES,
} from 'structure/user/WalletConnect/helper/wallet.const';
import { defaultNetwork } from '@dapp/multi-lib/network';
import { getStaticAssetUrl } from 'utils/url';

export const walletsConfig = (): WalletConfigType[] => {
  return [
    {
      id: 'metamask',
      title: WALLET_NAMES.METAMASK,
      icon: getStaticAssetUrl('/sfi/static/image/wallets/metamask.svg'),
      installed:
        // https://rainbowkit.com/docs/wallet-button
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof window !== 'undefined' && Boolean(window.ethereum?.isMetaMask),
      connector: 'injected',
      connectorId: WALLET_TYPES.METAMASK,
      downloadLink: 'https://metamask.app.link/dapp/pancakeswap.finance/',
      network: defaultNetwork.id,
      available: true,
    },
    {
      id: 'trust',
      title: WALLET_NAMES.TRUST,
      connector: 'walletconnect',
      icon: getStaticAssetUrl('/sfi/static/image/wallets/trust.svg'),
      connectorId: WALLET_TYPES.TRUST_WALLET,
      network: defaultNetwork.id,
      installed:
        typeof window !== 'undefined' &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (Boolean(window.ethereum?.isTrust) ||
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          Boolean(window.ethereum?.isTrustWallet)),
      downloadLink:
        'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph/related',
      available: true,
    },
    {
      id: 'walletconnect',
      title: WALLET_NAMES.WALLETCONNECT,
      icon: getStaticAssetUrl('/sfi/static/image/wallets/walletconnect.svg'),
      connector: 'walletconnect',
      connectorId: WALLET_TYPES.WALLET_CONNECT,
      network: defaultNetwork.id,
      installed: true,
      available: true,
    },
    {
      id: 'baseaccount',
      title: 'Coinbase Wallet',
      icon: getStaticAssetUrl('/sfi/static/image/wallets/coinbase.svg'),
      connector: 'baseaccount',
      connectorId: WALLET_TYPES.COINBASE_WALLET,
      network: defaultNetwork.id,
      installed: true,
      available: true,
    },
    {
      id: 'safe',
      title: 'Safe Wallet',
      icon: getStaticAssetUrl('/sfi/static/image/wallets/safe.svg'),
      connector: 'safe',
      connectorId: WALLET_TYPES.SAFE_WALLET,
      network: defaultNetwork.id,
      installed: typeof window !== 'undefined' && window.parent !== window,
      available: typeof window !== 'undefined' && window.parent !== window,
    },
    // {
    //   id: 'web3auth',
    //   title: 'Web 3 Auth Wallet',
    //   icon: '/static/image/wallets/web3auth_dark.svg',
    //   connector: 'web3auth',
    //   connectorId: WALLET_TYPES.WEB_3_AUTH,
    //   network: defaultNetwork.id,
    //   installed: true,
    // },
    {
      id: 'rabby',
      title: 'Rabby Wallet',
      icon: getStaticAssetUrl('/sfi/static/image/wallets/rabby.svg'),
      connector: 'rabby',
      connectorId: WALLET_TYPES.RABBY_WALLET,
      network: defaultNetwork.id,
      installed: true,
      available: true,
    },
  ];
};
